import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from "@material-ui/core/Typography";
import {UVT_MATERIAS} from "../Source/Materias";
import {USER_MAJOR} from "../App";
import {useAppContext} from "../libs/contextLib";

const useStyles = makeStyles({
    header: {
        paddingBottom: "25px"
    },
    table: {
        minWidth: 650,
    },
});

export default function BasicTable() {
    const classes = useStyles();
    const {userEmail} = useAppContext();
    const major = USER_MAJOR[userEmail];

    return (
        <>
            <Typography variant="h2" className={classes.header}>
                Calificaciones
            </Typography>
            <TableContainer>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell><b>Clave</b></TableCell>
                            <TableCell><b>Nombre de la materia</b></TableCell>
                            <TableCell><b>Semestre</b></TableCell>
                            <TableCell align="right"><b>Calificación</b></TableCell>
                            <TableCell align="right"><b>Extraordinario</b></TableCell>
                            <TableCell align="right"><b>Equivalencia</b></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Object.keys(UVT_MATERIAS[major]).map(o => UVT_MATERIAS[major][o].materias).flat().map((row) => (
                            <TableRow key={row.topicId}>
                                <TableCell component="th" scope="row">
                                    {row.topicId}
                                </TableCell>
                                <TableCell>{row.name}</TableCell>
                                <TableCell>{row.cuatrimestre}</TableCell>
                                <TableCell align="right">{row.calificacion}</TableCell>
                                <TableCell align="right">{row.extraordinario}</TableCell>
                                <TableCell align="right">{row.equivalencia}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}